export default "__VITE_ASSET__f7989768__"